/**
 * Created by Administrator on 2017/3/24.
 */
const menuDatas={
  home:{
    to: '/',text:'首页'
  },
  about:{
    to: 'about',text:'关于'
  },
  yysxx:{
    to: 'showui',text:'组件库'
  }
};

export {menuDatas}



// WEBPACK FOOTER //
// ./src/assets/datas/jsondata.js